export default __webpack_public_path__ + "static/media/school7.f36eb4e0.webp";